import useConfirm from "./useConfirm";
import { useContext, useEffect, useCallback } from "react";
import { PantallaEditContext } from "contexts";
import { useSafeState } from "./useSafeState";


export default function usePantallaEdit(setEstado) {
  const { Confirm } = useConfirm();
  const { hayCambios, setHayCambios } = useContext(PantallaEditContext);
  const [estadoCargado, setEstadoCargado] = useSafeState(false);
  const [confirmActive, setConfirmActive] = useSafeState(false);
  const [pendingLocation, setPendingLocation] = useSafeState(null);


   const navegar = (to) => {
    if (typeof to === "number") {
      window.history.go(to);
    } else if (typeof to === "string") {
      window.location.href = to;
    }
  };

  const setEntidad = useCallback(
    (newEstado, setearCambio = true) => {
      if (estadoCargado && setearCambio) {
        setHayCambios(true);
      }

      setEstado((prev) =>
        typeof newEstado === "function" ? newEstado(prev) : newEstado
      );
    },
    [estadoCargado]
  );

  const handleVolver = () => {
    if (hayCambios) {
      if (!confirmActive) {
        setConfirmActive(true);
        Confirm({
          title: "Tienes cambios sin guardar.",
          textBody: "¿Estás seguro de que quieres salir sin guardar?",
          onConfirm: () => {
            setConfirmActive(false);
            setHayCambios(false);
            window.history.back();
          },
          onCancel: () => {
            setConfirmActive(false);
          },
        });
      }
    } else {
      window.history.back();
    }
  };

  const handleNavigation = useCallback(
    (to) => {
      if (hayCambios) {
        if (!confirmActive) {
          setConfirmActive(true);
          setPendingLocation(to);
          Confirm({
            title: "Tienes cambios sin guardar.",
            textBody: "¿Estás seguro de que quieres salir sin guardar?",
            onConfirm: () => {
              setConfirmActive(false);
              setHayCambios(false);
              setPendingLocation(null);
              navegar(to); // 🔁 reemplazo de navigate(to)
            },
            onCancel: () => {
              setConfirmActive(false);
              setPendingLocation(null);
            },
          });
        }
        return false;
      }
      return true;
    },
    [hayCambios, confirmActive, Confirm]
  );

useEffect(() => {
    if (pendingLocation && !hayCambios) {
      navegar(pendingLocation);
      setPendingLocation(null);
    }
  }, [pendingLocation, hayCambios]);

  useEffect(() => {
    return () => {
      setConfirmActive(false);
      setPendingLocation(null);
    };
  }, []);

  return {
    setEntidad,
    setEstadoCargado,
    handleVolver,
    hayCambios,
    setHayCambios,
    handleNavigation,
  };
};

